var browsePageRootPaths = ["brand2", "brand", "seller", "category"];
export var getBrowseValue = function getBrowseValue(path) {
  var pathWithoutQuery = path.split("?")[0];
  var paths = pathWithoutQuery.split("/").filter(Boolean);

  if (browsePageRootPaths.includes(paths[0])) {
    return paths[1];
  }
};